import { getInitialStateFromConfig } from "helpers/form";

const config = {
    executionTimes: {
        config: {
            executionTime: {
                // field
                inputProps: { name: "executionTime", type: "time", skip: 600, placeholder: "08:00" },
            },
            id: {},
        },
        value: [],
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
